import { questionmark } from "@phonero/pux-icons/icons"
import { PuxPopover, PuxSheet } from "@phonero/pux-react"
import { useState } from "react"
import { IconButton } from "../Form/IconButton"

const linkedIcon =
  'data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13.1943 19.292C13.3816 19.4795 13.4868 19.7337 13.4868 19.9987C13.4868 20.2637 13.3816 20.5179 13.1943 20.7054L11.9521 21.955C10.6385 23.2678 8.85722 24.005 7.0001 24.0044C5.14297 24.0038 3.36214 23.2655 2.04937 21.9519C0.736593 20.6383 -0.000585533 18.857 3.4896e-07 16.9999C0.00058623 15.1427 0.738889 13.3619 2.05249 12.0491L5.06662 9.035C6.32836 7.77225 8.02497 7.03941 9.80927 6.98645C11.5936 6.93348 13.3307 7.5644 14.6651 8.75008C14.7635 8.83739 14.8439 8.94323 14.9014 9.06157C14.959 9.17991 14.9927 9.30842 15.0005 9.43978C15.0084 9.57114 14.9904 9.70276 14.9474 9.82714C14.9044 9.95152 14.8374 10.0662 14.7501 10.1647C14.6628 10.2631 14.5569 10.3434 14.4386 10.401C14.3202 10.4586 14.1917 10.4922 14.0604 10.5001C13.929 10.508 13.7974 10.49 13.673 10.447C13.5486 10.404 13.4339 10.337 13.3355 10.2497C12.3824 9.40328 11.142 8.95298 9.8679 8.99084C8.59383 9.0287 7.38234 9.55186 6.48121 10.4533L3.46708 13.4637C2.52948 14.4013 2.00274 15.673 2.00274 16.9989C2.00274 18.3249 2.52948 19.5966 3.46708 20.5342C4.40468 21.4718 5.67634 21.9985 7.00231 21.9985C8.32827 21.9985 9.59993 21.4718 10.5375 20.5342L11.7797 19.292C11.8725 19.1991 11.9828 19.1253 12.1041 19.075C12.2255 19.0247 12.3556 18.9988 12.487 18.9988C12.6183 18.9988 12.7484 19.0247 12.8698 19.075C12.9912 19.1253 13.1014 19.1991 13.1943 19.292ZM21.9517 2.04703C20.6379 0.736179 18.8578 0 17.0019 0C15.146 0 13.3659 0.736179 12.0521 2.04703L10.81 3.29042C10.6225 3.478 10.5173 3.73236 10.5174 3.99753C10.5175 4.2627 10.623 4.51696 10.8106 4.70438C10.9982 4.8918 11.2525 4.99703 11.5177 4.99691C11.7829 4.99679 12.0371 4.89134 12.2245 4.70376L13.4667 3.46162C14.4043 2.52402 15.6759 1.99728 17.0019 1.99728C18.3279 1.99728 19.5995 2.52402 20.5371 3.46162C21.4747 4.39922 22.0015 5.67088 22.0015 6.99684C22.0015 8.32281 21.4747 9.59447 20.5371 10.5321L17.523 13.5487C16.6214 14.4496 15.4096 14.9721 14.1356 15.0093C12.8615 15.0465 11.6214 14.5955 10.6687 13.7486C10.5703 13.6613 10.4556 13.5943 10.3312 13.5513C10.2068 13.5083 10.0752 13.4903 9.94385 13.4982C9.67856 13.5141 9.43047 13.6348 9.25415 13.8336C9.16685 13.9321 9.09979 14.0468 9.05682 14.1711C9.01384 14.2955 8.99578 14.4271 9.00367 14.5585C9.01961 14.8238 9.14027 15.0719 9.33913 15.2482C10.6732 16.4342 12.4101 17.0656 14.1944 17.0131C15.9787 16.9606 17.6755 16.2282 18.9376 14.9658L21.9517 11.9517C23.2633 10.6378 24 8.85711 24 7.00059C24 5.14408 23.2633 3.36342 21.9517 2.04953V2.04703Z" fill="currentColor"/>/</svg>'

interface InfoBoxProps {
  message?: React.ReactNode
  children?: React.ReactNode
  activateStopPropagation?: boolean
  activatePreventDefault?: boolean
  /** Controls the width and height of the icon-button, making it squared in size */
  size?: number
  noSpaceAround?: boolean
  icon?: string
}

export const InfoBoxLinked = (params: InfoBoxProps) => {
  return InfoBox({ ...params, icon: linkedIcon })
}

export const InfoBox = ({
  message,
  children,
  activateStopPropagation,
  activatePreventDefault,
  size,
  noSpaceAround,
  icon = questionmark,
}: InfoBoxProps) => {
  const [popoverState, setShowPopover] = useState<{
    showPopover: boolean
    event: any
  }>({
    showPopover: false,
    event: undefined,
  })

  /*activateStopPropagation property can now be set to avoid triggering buttons and other 
  clickable DOM-elements if the infobox is placed on these.

  activatePreventDefault works similarly, however, it explicitly prevents the default behaviour 
  of an element from happening. 

  The two parameters are not meant to be used at the same time*/
  const onClick = (e: any) => {
    e.persist()
    setShowPopover({ showPopover: true, event: e })
    activateStopPropagation && e.stopPropagation()
    activatePreventDefault && e.preventDefault()
  }

  return (
    <>
      <IconButton
        style={{ width: size, height: size }}
        icon={icon}
        title={"Klikk for mer informasjon"}
        fill={"clear"}
        onClick={onClick}
        noSpaceAround={noSpaceAround}
      />
      <PuxPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <PuxSheet>
          {message}
          {children}
        </PuxSheet>
      </PuxPopover>
    </>
  )
}
